import {
  Card,
  FieldWrapper,
  Heading,
  HelperText,
  InputWrapper,
  Label,
  MarkdownPreview,
} from '@frontendmentorio/design-system-v2';

export default function Retrospective({ solution }) {
  return (
    <Card
      aria-labelledby="solution-retro-heading"
      className="flex flex-col gap-5 p-5"
      role="group"
    >
      <Heading id="solution-retro-heading" level="5" tagName="span">
        Solution retrospective
      </Heading>

      <p>
        The solution retrospective helps you think about your project and share
        it with the community. Answer the three questions below to talk about
        your project, what you learned, and where you need support. Clear
        details help others understand and give useful feedback.
      </p>

      <FieldWrapper>
        <Label>
          What are you most proud of, and what would you do differently next
          time?
        </Label>

        <InputWrapper
          defaultValue={solution?.retrospective?.reflections}
          input={MarkdownPreview}
          name="retrospective.reflections"
          wrapperClassName="bg-gray-100 p-3 rounded-md"
        />
      </FieldWrapper>

      <FieldWrapper>
        <Label>
          What challenges did you encounter, and how did you overcome them?
        </Label>

        <InputWrapper
          defaultValue={solution?.retrospective?.challenges}
          input={MarkdownPreview}
          name="retrospective.challenges"
          wrapperClassName="bg-gray-100 p-3 rounded-md"
        />
      </FieldWrapper>

      <FieldWrapper>
        <Label>
          What specific areas of your project would you like help with?
        </Label>

        <HelperText>
          Be as specific as possible when asking questions or for feedback on
          areas of your code. This will increase your chances of receiving
          higher-quality input from others.
        </HelperText>

        <InputWrapper
          defaultValue={solution?.retrospective?.assistance}
          input={MarkdownPreview}
          name="retrospective.assistance"
          wrapperClassName="bg-gray-100 p-3 rounded-md"
        />
      </FieldWrapper>
    </Card>
  );
}
